const min = 0;
const max = 99999;

export const setId = () => {
  return Math.floor(Math.random() * (max - min)) + min;
};
